import {parsePhoneNumber} from "libphonenumber-js";

export const formatPhone = (ph) => {
    const phoneNumber = parsePhoneNumber(ph, 'US');
    return phoneNumber.formatNational();
}

